export default "__VITE_PUBLIC_ASSET__bd14def1__"